import { Mail as MailIcon } from '@mui/icons-material'
import { Box, Button, Dialog, DialogActions, DialogTitle, Typography } from '@mui/material'
import { t } from 'i18next'

import { useGlobalContext } from '../../Shared/Contexts/GlobalContext.jsx'

const ResetPasswordSuccess = () => {
  const {
    setResetPasswordDialog,
    setLoginDialog,
    resetPasswordSuccessDialog,
    setResetPasswordSuccessDialog
  } = useGlobalContext()

  const handleCloseResetPasswordSuccess = () => setResetPasswordDialog(false)

  const returnLoginPageHandler = () => {
    setResetPasswordSuccessDialog(false)
    setLoginDialog(true)
  }

  return (
    <Dialog
      id="resetPasswordSuccessDialog"
      maxWidth="sm"
      scroll="body"
      open={resetPasswordSuccessDialog}
      onClose={handleCloseResetPasswordSuccess}
    >
      <DialogTitle
        display="flex"
        justifyContent="center"
      >
        <Box
          sx={{
            background:
              'radial-gradient( 180px circle at 50% 50%, #ceeffe 50%, transparent 51% )'
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="baseline"
            sx={{
              position: 'relative',
              top: 'calc(50% - 30px)'
            }}
          >
            <MailIcon
              size={60}
              color="#0e81fc"
            />
          </Box>
          <Box mt={18}>
            <Typography
              variant="h3"
              align="center"
            >
              <strong>{t('users.resetPasswordLinkSent')}</strong>
            </Typography>
            <Typography
              variant="body2"
              align="center"
              sx={{ m: 2 }}
            >
              {t('users.checkYourInboxText')}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <DialogActions sx={{
        justifyContent: 'center',
        p: '16px'
      }}>
        <Button
          id="reset-password-dialog-button-return-login"
          sx={{ mt: 4 }}
          variant="contained"
          onClick={returnLoginPageHandler}
        >
          {t('users.returnToLogin')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ResetPasswordSuccess
